import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import { format } from "date-fns";

const state = {
  product: {
    name: '',
    purchasePrice: '',
    taxId: '',
    unitId: '',
    minimumQuantity: 1,
    hsn: '',
    barcode: '',
    isDisabled: false,
    quantity: 0,
    mrp : null,
    prices: [
      {
        startDate: format(new Date(), "YYYY-MM-DD"),
        price: 0,
        fromQuantity: 1,
        defaultDiscount: 0
      }
    ],
    productAttributes: [
      {
        attributeId: '',
        value: ''
      }
    ],
    metadata : {
      rackNumber : '',
      branch_price: ''
    },
    supplierId: ''

  },
  productUnits: [],
  productPriceTypes: [],
  productList: [],
  productUnit: {
    label : "",
    code :''
  },
  barcode : '',
};

const products = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}

export default products;